export const safeJsonParse = <T>(data: string): [T | null, boolean] => {
	try {
		return [JSON.parse(data) as T, true];
	} catch {
		return [null, false];
	}
};
